module.exports = __webpack_public_path__ + "img/home_contact.f09a802a.svg";